

export default class FileUtils {

	static getFontAwesomeIconePeloNome(arquivo) {

		if (arquivo.includes('doc') || arquivo.includes('docx')) {
			return 'fas fa-file-word';
		} else if (arquivo.includes('xls') || arquivo.includes('xlsx')) {
			return 'fas fa-file-excel';
		} else if (arquivo.includes('pdf')) {
			return 'fas fa-file-pdf';
		} else if (arquivo.includes('png') || arquivo.includes('jpg') || arquivo.includes('jpeg')) {
			return 'fas fa-file-image';
		} else {
			return 'fas fa-file';
		}
	}

}
